import { httpRequest } from "../../../http";

import { NetworkResource } from "@models/networkResource";
import { NetworkResourceSerializer } from "@models/serializers/networkResourceSerializer";

export type NetworkResourceListFilters = {
  organization_ids?: number[];
  resource_ids?: number[];
  types?: string[];
  networks?: string[];
};

export class CommandListNetworkResources {
  async run(filters: NetworkResourceListFilters): Promise<NetworkResource[]> {
    const searchParams = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => searchParams.append(key, String(item)));
      } else {
        searchParams.append(key, String(value));
      }
    });

    try {
      const response = await httpRequest<any[]>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/?${searchParams.toString()}`,
        { method: "GET" },
      );

      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching network accounts:", error);
      throw error;
    }
  }

  private deserialize(data: any): NetworkResource[] {
    const serializer = new NetworkResourceSerializer();
    return serializer.deserializeList(data);
  }
}
